import { render, staticRenderFns } from "./KiddieSupport.vue?vue&type=template&id=1ac5ee1a&scoped=true&lang=pug"
import script from "./KiddieSupport.vue?vue&type=script&lang=js"
export * from "./KiddieSupport.vue?vue&type=script&lang=js"
import style0 from "./KiddieSupport.vue?vue&type=style&index=0&id=1ac5ee1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac5ee1a",
  null
  
)

export default component.exports